import React from 'react';
import styles from './index.module.css';
import BackgroundImage from '../../assets/images/zogeregeld/greyheader.png';

const HomePage = () => {
    return (
        <div
            className={styles.container}
            style={{
                backgroundImage: `linear-gradient(0deg, white 0%, transparent 10%), url(${BackgroundImage})`,
            }}
        >
            <div className={styles.wrapper}>
                <a className={styles.card} href={'/zogeregeld'}>
                    <span>Zo Geregeld</span>
                </a>
                <a className={styles.card} href={'/zogefixt'}>
                    <span>Zo Gefixt</span>
                </a>
            </div>
        </div>
    );
};

export default HomePage;
